module.exports = __webpack_public_path__ + "static/feature4-7fc27a1392146142b241e604e13d65b2.png";